import InfoDataItem from 'components/Common/InfoDataItem/InfoDataItem';
import { useMergedStyles } from 'hooks/useMergedStyles';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { Styles } from 'types/styles';
import TooltipComponent from 'components/Common/TooltipComponent/TooltipComponent';

import styles from './StorageProviderItemSecondaryStats.module.scss';

type Props = {
  dataCenterCount: number;
  country: string[] | null;
  newStyles?: Styles;
};
const StorageProviderItemSecondaryStats: FC<Props> = ({
  newStyles = {},
  dataCenterCount,
  country,
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);
  const { t } = useTranslation('explore');

  const additionalLocations =
    country && country?.length > 1 ? `+${country.length - 1}` : null;

  return (
    <div className={mergedStyles['storage-provider-secondary-stats-wrapper']}>
      <div className={mergedStyles['storage-provider-secondary-stats-location']}>
        <label>{t('location')}</label>
        <div className={mergedStyles['storage-provider-secondary-stats-location-item']}>
          {country?.length ? country[0] : t('unknown')}
          {additionalLocations && (
            <TooltipComponent
              html={
                <div className={mergedStyles['tooltip-datacenters']}>
                  {country?.slice(1).map((country) => (
                    <div key={country} className={mergedStyles['tooltip-country']}>
                      {country}
                    </div>
                  ))}
                </div>
              }
              newStyles={mergedStyles}
              position="right"
              arrow
              theme="pink500"
            >
              <div
                className={
                  mergedStyles[
                    'storage-provider-secondary-stats-location-item-additional-locations'
                  ]
                }
              >
                {additionalLocations}
              </div>
            </TooltipComponent>
          )}
        </div>
      </div>
      <InfoDataItem
        infoValue={{ type: 'string', data: dataCenterCount }}
        label={t('datacenters')}
        newStyles={mergedStyles}
        decimalPlaces={2}
      />
    </div>
  );
};

export default StorageProviderItemSecondaryStats;
